const NOTIFICATIONS_ACTION_TYPES = {
  GET: {
    IN_PROGRESS: 'NOTIFICATIONS_IN_PROGRESS',
    SUCCESS: 'NOTIFICATIONS_SUCCESS',
    ERROR: 'NOTIFICATIONS_ERROR',
  },
  DELETE: {
    IN_PROGRESS: 'NOTIFICATION_DELETE_IN_PROGRESS',
    SUCCESS: 'NOTIFICATION_DELETE_SUCCESS',
    ERROR: 'NOTIFICATION_DELETE_ERROR',
  },
};

export default NOTIFICATIONS_ACTION_TYPES;
